/** Set on documentElement when the Learning Lab banner is mounted; `0px` when inactive. */
export const LEARNING_LAB_BANNER_HEIGHT_CSS_VAR = '--apt-learning-lab-banner-height';

/** Sticky `top` for site headers while the lab banner is pinned above them. */
export function learningLabStickyHeaderTop(labActive: boolean): number | string {
  return labActive ? `var(${LEARNING_LAB_BANNER_HEIGHT_CSS_VAR}, 72px)` : 0;
}
